import {EventParticipant} from "./EventParticipant";

export interface SaveUserConnection {
  status: number,
  timestampAdded: number
}

export class UserConnection implements SaveUserConnection {

  static readonly CONNECTION_REQUEST_STATUS_OK = 1;
  static readonly CONNECTION_REQUEST_STATUS_BLOCKED = -1;
  static readonly CONNECTION_REQUEST_STATUS_AUTO_ACCEPTED = 2;

  public participant: EventParticipant;

  public constructor(public id: string,
                     public status: number,
                     public timestampAdded: number) {

  }

  static fromAngularFireSnapshots(snapshots: any) : UserConnection[] {
    return snapshots.map(snap => UserConnection._fromSnapshot(snap.key, snap.payload.val()));
  }

  private static _fromSnapshot(key: string, {status, timestampAdded}) {
    return new UserConnection(key, status, timestampAdded);
  }
}



// WEBPACK FOOTER //
// ./src/providers/communication/models/UserConnection.ts